<template>
    <h2 style="line-height: 120%">
        {{ title }}
    </h2>
</template>

<script lang="ts">
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        white: Boolean,
        small: Boolean,
        xsmall: Boolean,
    },
};
</script>
